"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icons = require("../Icons");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var _StyledDiv = (0, _styledComponents["default"])("div").withConfig({
  displayName: "PanelCollapsible___StyledDiv",
  componentId: "imcvm3-0"
})(["height:", ";max-height:", ";background-color:", ";transition:height 200ms linear;display:flex;overflow:hidden;"], function (_ref) {
  var collapsed = _ref.collapsed;
  return !collapsed ? '140px' : '50px';
}, function (_ref2) {
  var maxExpandedHeight = _ref2.maxExpandedHeight;
  return maxExpandedHeight;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.color.secondary;
});

var _StyledDiv2 = (0, _styledComponents["default"])("div").withConfig({
  displayName: "PanelCollapsible___StyledDiv2",
  componentId: "imcvm3-1"
})(["{flex:1;}"]);

var _StyledDiv3 = (0, _styledComponents["default"])("div").withConfig({
  displayName: "PanelCollapsible___StyledDiv3",
  componentId: "imcvm3-2"
})(["padding:15px 10px;flex:0;"]);

var _StyledCaretDown = (0, _styledComponents["default"])(_Icons.CaretDown).withConfig({
  displayName: "PanelCollapsible___StyledCaretDown",
  componentId: "imcvm3-3"
})(["width:15px;height:20px;color:", ";transform:", ";transition:all 200ms linear;"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.color.white;
}, function (_ref5) {
  var collapsed = _ref5.collapsed;
  return !collapsed && 'rotate(180deg)';
});

var PanelCollapsible = function PanelCollapsible(_ref6) {
  var collapsedProp = _ref6.collapsed,
      className = _ref6.className,
      maxExpandedHeight = _ref6.maxExpandedHeight,
      children = _ref6.children;

  var _useState = (0, _react.useState)(collapsedProp),
      _useState2 = _slicedToArray(_useState, 2),
      collapsed = _useState2[0],
      setCollapsed = _useState2[1];

  (0, _react.useEffect)(function () {
    setCollapsed(collapsedProp);
  }, [collapsedProp]);
  return /*#__PURE__*/_react["default"].createElement(_StyledDiv, {
    className: className,
    collapsed: collapsed,
    maxExpandedHeight: maxExpandedHeight
  }, /*#__PURE__*/_react["default"].createElement(_StyledDiv2, null, children), /*#__PURE__*/_react["default"].createElement(_StyledDiv3, {
    onClick: function onClick() {
      setCollapsed(!collapsed);
    }
  }, /*#__PURE__*/_react["default"].createElement(_StyledCaretDown, {
    collapsed: collapsed
  })));
};

PanelCollapsible.defaultProps = {
  collapsed: true
};
PanelCollapsible.propTypes = {
  collapsed: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  maxExpandedHeight: _propTypes["default"].string,
  children: _propTypes["default"].any
};
var _default = PanelCollapsible;
exports["default"] = _default;